import * as React from "react";
import type { SVGProps } from "react";
const SvgLivedaten = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5 2a3 3 0 0 0-3 3v9a1 1 0 1 0 2 0V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v9.048c-1.232-1.49-1.844-3.044-2.382-4.414l-.024-.06c-.32-.816-.66-1.684-1.146-2.33C15.888 6.498 15.108 6 14 6c-1.154 0-1.986.604-2.568 1.388-.555.746-.94 1.72-1.256 2.67-.159.477-.309.975-.456 1.462l-.007.025c-.151.5-.3.99-.459 1.467-.32.963-.662 1.797-1.086 2.433C6.618 17.77 4.892 18 4 18a1 1 0 1 0-2 0v1a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm-.28 17.96A1 1 0 0 0 5 20h14a1 1 0 0 0 1-1v-2.106l-.093-.083-.071-.064c-2.416-2.147-3.368-4.57-4.055-6.32l-.024-.061c-.36-.918-.609-1.523-.909-1.922C14.611 8.127 14.392 8 14 8c-.346 0-.64.146-.963.581-.352.473-.655 1.185-.963 2.11-.15.45-.293.924-.443 1.421l-.004.011c-.15.496-.306 1.014-.475 1.521-.335 1.006-.744 2.047-1.32 2.91-1.692 2.538-3.69 3.247-5.112 3.406"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgLivedaten;
